import Swiper from 'swiper';
import {Navigation, Pagination} from "swiper/swiper.esm";
Swiper.use([Navigation]);

const industrySwiper = new Swiper(".services-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    direction: 'horizontal',
    loop: true,
    navigation: {
        nextEl: '.services-swiper-button-next',
        prevEl: '.services-swiper-button-prev',
    },
    breakpoints: {
        675: {
            slidesPerView: 2
        },
        992: {
            slidesPerView: 3
        },
        1300: {
            slidesPerView: 4
        },
        1500: {
            slidesPerView: 5
        }
    }
});
